module.exports = __webpack_public_path__ + "img/5.01e7b047.png";